/**
 * A simple enum representing the measurement system to use (metric or imperial)
 */
export enum GeckoMeasurementSystem {
  Imperial = 'imperial',
  Metric = 'metric',
}
